import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MailIcon } from 'lucide-react';
import { contact } from '../data/contact';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" className="relative w-full overflow-hidden pb-20 pt-10 md:pb-28 md:pt-16" data-id="element-64" data-mp="9lv00naxu9u9">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-12 px-6 lg:grid-cols-[1.05fr_1fr] lg:gap-16" data-id="element-65" data-mp="4mrt0xbedtjn">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} data-id="element-66" data-mp="128phdbcgkt3i">
          <p className="font-display text-sm italic text-brique" data-id="element-67" data-mp="sai3j1dgur5q">Artisan peintre · {contact.name}</p>
          <h1 className="mt-4 font-display text-[2.75rem] leading-[1.05] tracking-tight text-ink sm:text-6xl" data-id="element-68" data-mp="nczvreb6qhzb">
            Des finitions nettes,
            <br data-id="element-69" data-mp="3czfme2gnud7m" />
            un chantier tenu.
          </h1>
          <p className="mt-6 max-w-lg text-lg leading-relaxed text-ink-soft" data-id="element-70" data-mp="381e61pamcrzu">
            Peinture, finitions, vitrerie et remise en état de logements. Un seul artisan sur votre
            chantier, du devis au coup de balai final.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-3" data-id="element-71" data-mp="3o59cvlo65afl">
            <a href="#contact" className="inline-flex items-center gap-2 rounded-full bg-brique px-6 py-3.5 text-base font-semibold text-sand-50 transition-colors duration-150 ease-out hover:bg-brique-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink" data-id="element-72" data-mp="399tc6xt32ga8">
              Demander un devis gratuit
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="2qleookhz5ke6" />
            </a>
            <a href={`mailto:${contact.email}`} className="inline-flex items-center gap-2 rounded-full border border-sand-300 px-6 py-3.5 text-base font-medium text-ink transition-colors duration-150 ease-out hover:border-ink hover:bg-sand-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brique" data-id="element-74" data-mp="2vjzowjx8842m">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-75" data-mp="naa0aponrglg" />
              Écrire un message
            </a>
          </div>

          <dl className="mt-12 grid max-w-md grid-cols-3 gap-6 border-t border-sand-200 pt-6" data-id="element-76" data-mp="ichy92uaue3j">
            {[{
            value: 'Devis',
            label: 'gratuit et détaillé'
          }, {
            value: '48 h',
            label: 'pour une réponse'
          }, {
            value: 'Propre',
            label: 'chantier protégé'
          }].map(item => <div key={item.value} data-id="element-77" data-mp="112pvx5f8cccc">
                <dt className="font-display text-xl text-ink" data-id="element-78" data-mp="111okgzuaxnu3">{item.value}</dt>
                <dd className="mt-1 text-sm leading-snug text-ink-muted" data-id="element-79" data-mp="x1nuqj1r5q7q">{item.label}</dd>
              </div>)}
          </dl>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease
      }} className="relative" data-id="element-80" data-mp="3lu9tqr7n9g6h">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/6d3efb0e-f675-41b5-a116-0c7d8533be0c.jpg" alt="Tony Rumor, en tenue de peintre, appliquant une peinture blanche au rouleau sur un mur d'appartement lumineux" className="aspect-[4/5] w-full rounded-[2rem] object-cover" data-id="element-81" data-mp="1x7hw9eyk651e" />
          <div className="absolute -bottom-6 left-6 right-12 rounded-2xl bg-ink px-6 py-5 text-sand-50 sm:right-auto sm:max-w-xs" data-id="element-82" data-mp="2g0luzeqmv82v">
            <p className="font-display text-lg leading-snug" data-id="element-83" data-mp="2kx2flyymj4b7">« Je rends le logement comme j'aimerais le retrouver. »</p>
            <p className="mt-2 text-sm text-sand-300" data-id="element-84" data-mp="2oyo0o7lbaowh">{contact.name}, fondateur</p>
          </div>
        </motion.div>
      </div>
    </section>;
}